export default __webpack_public_path__ + "static/logo-white-f628094424f90f3e07d8a7f2d1446b66.svg";